import * as actions from '../actionTypes'

const initialState = {
  masterNumber: '',
  emailAddress: '',
  confirmEmailAddress: '',
  phoneNumber: '',
}

const YourInformationReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.MASTER_NUMBER: {
      return {
        ...state,
        masterNumber: action.payload.description,
      }
    }
    case actions.EMAIL_ADDRESS: {
      return {
        ...state,
        emailAddress: action.payload.description,
      }
    }
    case actions.CONFIRM_EMAIL_ADDRESS: {
      return {
        ...state,
        confirmEmailAddress: action.payload.description,
      }
    }
    case actions.PHONE_NUMBER: {
      return {
        ...state,
        phoneNumber: action.payload.description,
      }
    }
    case actions.CLEAR_ALL_FIELDS: {
      return initialState
    }
    case actions.CLEAR_ALL: {
      return initialState
    }
    default: {
      return state
    }
  }
}
export default YourInformationReducer
